import styled from 'styled-components';
import { theme, media } from '../../styles/theme';

export const Card = styled.div`
  background-color: ${theme.colors.white};
  border-radius: ${theme.borderRadius.xl};
  padding: ${({ padding }) => padding || theme.spacing.lg};
  box-shadow: ${theme.shadows.sm};
  transition: all ${theme.transitions.duration.base} ${theme.transitions.easing.easeOut};
  border: 1px solid ${theme.colors.border};
  position: relative;
  overflow: hidden;
  
  &:hover {
    box-shadow: ${theme.shadows.md};
  }

  /* Gradient border effect on hover */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: ${theme.borderRadius.lg};
    padding: 1px;
    background: linear-gradient(135deg, ${theme.colors.primary}, ${theme.colors.accentTeal});
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity ${theme.transitions.duration.base};
    pointer-events: none;
    z-index: -1;
  }

  ${({ hover }) => hover && `
    &:hover {
      box-shadow: ${theme.shadows.lg};
      transform: translateY(-2px);
      border-color: ${theme.colors.primary}40;
      
      &::before {
        opacity: 1;
      }
    }
  `}

  ${({ clickable }) => clickable && `
    cursor: pointer;
    
    &:hover {
      box-shadow: ${theme.shadows.lg};
      transform: translateY(-2px);
    }
    
    &:active {
      transform: translateY(0);
      box-shadow: ${theme.shadows.md};
    }
  `}

  ${({ variant }) => {
    if (variant === 'elevated') {
      return `
        box-shadow: ${theme.shadows.xl};
        border: none;
      `;
    }
    if (variant === 'outlined') {
      return `
        box-shadow: none;
        border: 2px solid ${theme.colors.border};
      `;
    }
    return '';
  }}

  ${media.down.sm} {
    padding: ${theme.spacing.md};
    border-radius: ${theme.borderRadius.md};
  }
`;

